import { Component, signal, OnInit, Inject, inject, PLATFORM_ID } from '@angular/core';
import { Router, RouterOutlet, Event, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { TenantService } from './core/tenant/tenant';
import { Title, Meta } from '@angular/platform-browser';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { TenantConfigService } from './core/config/tenant-config';
import { Header } from "./shared/components/header/header";
import { State } from "./shared/components/state/state";
import { Country } from "./shared/components/country/country";
import { StateService } from './core/services/state.service';
import { Footer } from "./shared/components/footer/footer";
import { OrderSelectionService } from './core/services/order-selection.service';
import { OrderProcessingService } from './core/services/order-processing';
@Component({
    selector: 'app-root',
    imports: [RouterOutlet, Header, State, Country, Footer],
    templateUrl: './app.html',
    styleUrl: './app.scss'
})
export class App {
    public settings: any = null;

    /** Exposes the detected US state code to the template so <app-state> stays in sync */
    readonly stateCode = inject(StateService).stateCode;
    readonly showSelectState = inject(StateService).showSelectState;
    readonly isOrderPage = inject(StateService).isOrderPage;
    readonly sidebarSection = inject(StateService).sidebarSection;
    readonly hasSidebar = inject(StateService).hasSidebar;
    readonly orderSelection = inject(OrderSelectionService);
    readonly orderProcessing = inject(OrderProcessingService);
    constructor(private tenant: TenantService, private configService: TenantConfigService, private titleService: Title,
        @Inject(DOCUMENT) private document: Document
    ) {
        this.tenant.getDomain();

        this.router.events.subscribe((event: Event) => {
            if (event instanceof NavigationStart) {
                this.isRouting.set(true);
            } else if (
                event instanceof NavigationEnd ||
                event instanceof NavigationCancel ||
                event instanceof NavigationError
            ) {
                this.isRouting.set(false);
            }
        });
    }
    
    public readonly isRouting = signal(false);
    // protected readonly title = signal('embassy')
    // ;

    private router = inject(Router);
    private platformId = inject(PLATFORM_ID);
    private meta = inject(Meta);

    isNotBusinessDocs(): boolean {
        if (!isPlatformBrowser(this.platformId)) {
            return false;
        }
        const cleanUrl = this.router.url.split('?')[0].split('#')[0];
        const segments = cleanUrl.split('/').filter(Boolean);
       return !segments.includes('business-documents') ;
    }

    isNotPersonalDocs(): boolean {
        if (!isPlatformBrowser(this.platformId)) {
            return false;
        }
        const cleanUrl = this.router.url.split('?')[0].split('#')[0];
        const segments = cleanUrl.split('/').filter(Boolean);
       return !segments.includes('personal-documents') ;
    }

    ngOnInit() {
        // Retrieve the settings that were already loaded during APP_INITIALIZER
        this.settings = this.configService.settings;
        const settings = this.settings;

        // Set the title if it exists in the API response
        if (settings && settings.title) {
            this.titleService.setTitle(settings.title);
        }

        // Set Google Search Console verification tag
        if (settings && settings.seo_search_console) {
            let content = settings.seo_search_console;
            const match = content.match(/content=["']([^"']+)["']/i);
            if (match && match[1]) {
                content = match[1];
            }
            this.meta.updateTag({ name: 'google-site-verification', content: content });
        }

        // NOTE: Favicon and theme are already applied by TenantConfigService
        // during APP_INITIALIZER — no need to duplicate here.
    }
}
